import { IconEye } from "@tabler/icons-react";
import { buttonVariants } from "@/components/ui/button";
import { STRATEGY_PRODUCT } from "@/mocks/strategy-product";
import { StrategyAssetButton } from "./StrategyAssetButton";

export const GENERIC_REPORT_URL = "/fixtures/strategy-report.pdf";

export function ReportLink({ asin, label = "预览" }: { asin: string; label?: string }) {
  if (asin === STRATEGY_PRODUCT.asin) {
    return (
      <StrategyAssetButton
        kind="report"
        action="preview"
        label={label}
        fileName={STRATEGY_PRODUCT.reportFileName}
      />
    );
  }
  return (
    <a
      className={buttonVariants({ variant: "outline" })}
      href={GENERIC_REPORT_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      <IconEye data-icon="inline-start" />
      {label}
    </a>
  );
}
